// @flow
import Merchant from '../lib/Merchant';
import actionTypes from './actionTypes';
import type { TAction } from './index';


export type TMerchantsQuery = { name: string };
export type TMerchantsState = {
  query: TMerchantsQuery,
  list: Array<Merchant>,
};

function getInitialState(): TMerchantsState {
  return {
    query: { name: '' },
    list: [],
  };
}

export default function reducer(state: TMerchantsState = getInitialState(), action: TAction): TMerchantsState {
  switch (action.type) {
    case actionTypes.FETCH_MERCHANTS:
      return { ...state, ...action.payload.merchants };
    default: return state;
  }
}
